import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { ActionPerformed, DeliveredNotifications, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';
import { NotificationEvent } from '../models/notification/notification-types';
import { GlobalConstants } from '../constant/constant';
import { DateTimeHelper } from '../utils/date-time-helper';

@Injectable()
export class PushNotificationService {
  isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');
  private emitPushNotification = new Subject<NotificationEvent>();
  pushNotificationChange = this.emitPushNotification.asObservable();

  constructor() {}

  listenForEvents() {
    if (this.isPushNotificationsAvailable) {
      PushNotifications.removeAllListeners();

      PushNotifications.addListener('pushNotificationReceived', async (notification: PushNotificationSchema) => {
        this.emitPushNotification.next({ data: { date: DateTimeHelper.getUtcNowString(), notification: notification, content: notification.data, isRead: false }, type: 'received' });
      });

      PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
        this.emitPushNotification.next({
          data: { date: DateTimeHelper.getUtcNowString(), notification: notification, content: notification.notification.data, actionId: notification.actionId, inputValue: notification.inputValue, isRead: false },
          type: 'performed',
        });
      });
    }
  }

  registerPush() {
    if (this.isPushNotificationsAvailable) {
      PushNotifications.requestPermissions().then(permission => {
        if (permission.receive === 'granted') {
          PushNotifications.addListener('registration', (token: Token) => {
            localStorage.setItem(GlobalConstants.FIREBASE_TOKEN, token.value);
          });
          PushNotifications.register();
        }
      });

      PushNotifications.removeAllListeners();
      PushNotifications.addListener('registrationError', (error: any) => {
        console.log('Error: ' + JSON.stringify(error));
      });

      PushNotifications.addListener('pushNotificationReceived', async (notification: PushNotificationSchema) => {
        this.emitPushNotification.next({ data: { date: DateTimeHelper.getUtcNowString(), notification: notification, content: notification.data, isRead: false }, type: 'received' });
      });

      PushNotifications.addListener('pushNotificationActionPerformed', async (notification: ActionPerformed) => {
        this.emitPushNotification.next({
          data: { date: DateTimeHelper.getUtcNowString(), notification: notification, content: notification.notification.data, actionId: notification.actionId, inputValue: notification.inputValue, isRead: false },
          type: 'performed',
        });
      });
    }
  }

  removeDeliveredNotifications(notifications: DeliveredNotifications) {
    if (this.isPushNotificationsAvailable) {
      PushNotifications.removeDeliveredNotifications(notifications);
    }
  }
}
